import React from 'react'
import './bids.css'
import { AiFillHeart,AiOutlineHeart } from "react-icons/ai";
import seller1 from '../../assets/GroupImages1.jpg'
import seller2 from '../../assets/wallpaper.jpg'
import seller3 from '../../assets/wallpaperImages.jpg'
import seller4 from '../../assets/BigFacecaptain10.jpg'
import seller5 from '../../assets/BigFacerightshare.jpg'
import seller6 from '../../assets/funnyhexaeye10.png'
import seller7 from '../../assets/funnyhexaeye11.png'
import seller8 from '../../assets/BigFace68.png'



import { Link } from 'react-router-dom';

const Bids = ({title}) => {
  return (
    <div className='bids section__padding' style={{marginTop: 200}}>
      <div className="bids-container">
        <div style={{color:'white', width: '60%', paddingBottom: 50}}>
          <h2>Who we are</h2>
          <h3 style={{margin: 5}}>HexaEye's: The Creative's ART</h3>
          <p style={{fontSize: 17, margin: 5, paddingTop: 10}}>HexaEye's are ART collection, Creative, and Dreams. Our Community is a Home For those  seeking real connection as we all contribute to the future of web3 art, culture, and technology.</p>

          <p style={{fontSize: 17, margin: 5, paddingTop: 10}}> I show you that the art is generated in my dreams but HexaEyes comes with a lot of things and one thing is that the name of Hexaie is not generated from my side, that coming name is also Hexaise and my art thing and if nothing So. The background color is uniform and black. The thing is that the color you choose should be similar and match the black background color.</p>
          <p style={{fontSize: 17, margin: 5, paddingTop: 10}}>It doesn’t have to be best way. We’re in the midst of a cultural revolution—a digital renaissance—in which art is being transformed into something everyone can appreciate, own, and share. Our goal is an 1,00,000 strong collection of unique, hand drwn NFTS with a deeper Mining Make your NFT as Brand</p>
      </div>
        <div className="bids-container-text">
          <h1>{title}</h1>
        </div>
        
        <div className="bids-container-card">
        <div className="card-column" >
            <div className="bids-card">
              <div className="bids-card-top">
                <img src={seller6} alt="" />
              <p className="bids-title">HexaEyes Empty Body Design</p>
              </div>
            </div>
            
          </div>
          <div className="card-column" >
            <div className="bids-card">
              <div className="bids-card-top">
                <img src={seller7} alt="" />
                <p className="bids-title">HexaEyes Empty Body Design</p>
              </div>
            </div>
          </div>
          <div className="card-column" >
            <div className="bids-card">
              <div className="bids-card-top">
                <img src={seller8} alt="" />
                <p className="bids-title">HexaEyes in Dubai</p>
              </div>
            </div>
          </div>
          </div>
          <div className="bids-container-card">
          <div className="card-column" >
            <div className="bids-card">
              <div className="bids-card-top">
                <img src={seller1} alt=""/>
              <p className="bids-title">Wallpaper Animals Love</p>
              </div>
            </div>
          </div>
          <div className="card-column" >
            <div className="bids-card">
              <div className="bids-card-top">
                <img src={seller2} alt="" />
              <p className="bids-title">Painting World</p>
              </div>
            </div>
          </div>
          <div className="card-column" >
            <div className="bids-card">
              <div className="bids-card-top">
                <img src={seller3} alt="" />
              <p className="bids-title">Paint Color on Wall</p>
              </div>
            </div>
          </div>
          <div className="card-column" >
            <div className="bids-card">
              <div className="bids-card-top">
                <img src={seller4} alt="" />
              <p className="bids-title">HexaEyes Captain</p>
              </div>
            </div>
          </div>
          <div className="card-column" >
            <div className="bids-card">
              <div className="bids-card-top">
                <img src={seller5} alt="" />
              <p className="bids-title">HexaEyes Enjoy Life</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Bids
